/**
* this file contains all table column definitions for the transaction table
*
* Created by Tom on 24/06/18
*/
import moment from 'moment'
import { intlNumberFormatter } from '../../utility/utilities'
import React, { Component}  from 'react';

const tableColumns = [
    {
        id: "Date",
        Header: "Date",
        accessor:d => d.date,
        headerClassName: "tTable__header",
        Cell: d => { return <span>{ moment(d.original.date).format("DD MMM YY") }</span>; },
        style: {
            textAlign: 'left'
        }
    },
    {
        id: "Description",
        Header: "Description",
        accessor:d => d.description,
        headerClassName: "tTable__header",
        width: 250,
        style: {
            textAlign: 'left'
        }
    },
    {
        id: "CashOut",
        Header: "Cash Out",
        accessor: d => Number(d.cash_out),
        Cell: d => { return <span>{ intlNumberFormatter('en-AU', 'currency', 'AUD', parseFloat(d.original.cash_out)) }</span>; },
        headerClassName: "tTable__header right__align",
        style: {
            textAlign: 'right'
        }
    },
    {
        id: "CashIn",
        Header: "Cash In",
        accessor: d => Number(d.cash_in),
        Cell: d => { return <span>{ intlNumberFormatter('en-AU', 'currency', 'AUD', parseFloat(d.original.cash_in)) }</span>; },
        headerClassName: "tTable__header right__align",
        style: {
            textAlign: 'right'
        }
    },
    {
        id: "Balance",
        Header: "Balance",
        accessor: d => Number(d.running_total),
        Cell: d => { return <span>{ intlNumberFormatter('en-AU', 'currency', 'AUD', parseFloat(d.original.running_total)) }</span>; },
        headerClassName: "tTable__header right__align",
        style: {
            textAlign: 'right'
        }
    }
]

export default tableColumns



// WEBPACK FOOTER //
// ./src/components/Transaction/tableColumns.js